//
// Shared constants for use throughout the OIS Service & Components
//

/**
 * Names of Flags to be used to determine when API calls are in
 * progress or not.
 *
 * Note: There should be one name unique to each API call.
 */
export const LOADER_TYPES = {
  OIS_METADATA: "oisMetadata",
  OIS_DATA: "oisData",
  EPROTOCOL_ACTIVITY: "eProtocolActivity",
  UPLOAD_ENVIRONMENTS: "uploadEnvironments",
  UPLOAD_TO_ONCORE: "uploadToOnCore",
  DOWNLOAD_DATA: "downloadData",
};

/**
 * OIS Dashboard Filter Panel mapping
 * of element to API-based value name
 */
export const OIS_FILTER_TYPES = {
  ACTION: "action",
};

export const OIS_FILTER_OPTIONS = {
  actions: [
    { label: "Continuing Review", value: "review" },
    { label: "Participants Load", value: "participants" },
    { label: "Load Protocol Data", value: "training" },
  ],
};

export const UPLOAD_TO_ONCORE_FILTER_TYPES = {
  ONCORE_ENVIRONMENT: "oncoreEnvironment",
};

export const UPLOAD_ENVIRONMENTS = {
  environments: [
    { label: "Production", value: "production" },
    { label: "Tango", value: "tango" },
    { label: "Test", value: "test" },
    { label: "Indigo", value: "indigo" },
    { label: "Training", value: "training" },
    { label: "Staging", value: "staging" },
    { label: "Cloud Production", value: "cloudproduction" },
    { label: "Shadow", value: "shadow" },
  ],
};
